export enum JobApplicationSource {
  SPAM = 'SPAM',
  INBOUND = 'INBOUND',
  REFERRAL = 'REFERRAL',
  WEBINAR = 'WEBINAR',
  INDEED = 'INDEED',
  SUBITO = 'SUBITO',
  SPAM_LINKEDIN = 'SPAM_LINKEDIN',
  LINKEDIN = 'LINKEDIN',
  REFERRAL_AGENZIA = 'REFERRAL_AGENZIA',
}
